<template>
    <div :class="['address-input', 'standard', theme]">
        <div class="left-box">
            <input
                ref="input"
                type="text"
                autocomplete="off"
                name="address"
                class="input"
                :placeholder="cmpPlaceholder"
                :style="{ borderColor: inputBoderColor || '' }"
                v-model="address"
                @focus="onFocus"
                @compositionstart="onCompositionstart"
                @compositionend="onCompositionend"
                @input="onInput"
                @blur="onBlur"
                @keydown="onKeyDown"
            />
            <div
                class="close-box"
                :class="{ show: !!address }"
                @click="clearAddress"
                role="button"
                tabindex="0"
                :aria-label="'Clear address'"
            >
                <span class="iconfont icon-search-close" aria-hidden="true"></span>
            </div>
            <span class="iconfont icon-search" @click="onSubmit" role="button" tabindex="0" :aria-label="'Search'"></span>
        </div>
        <div class="right-box">
            <div
                class="submit-btn"
                @click="onSubmit"
                :style="submitStyle"
                :class="{ 'submit-disabled': submitDisabled }"
            >
                <i v-if="icon" :class="'iconfont ' + icon"></i>
                <div
                    class="submit"
                    v-html="submitText || $t('common:submit')"
                ></div>
            </div>
        </div>
        <div v-show="errorShow" class="empty-error">
            <span class="iconfont icon-error" aria-hidden="true"></span>
            <span class="error-text">{{
                $t('common:validate.validAddress')
            }}</span>
        </div>
    </div>
</template>

<script>
import common from './common';
export default {
    mixins: [common]
};
</script>

<style lang="scss">
@import '../../theme/media.scss';
@import '../../theme/mixin.scss';
.address-input.standard {
    width: 716px;
    max-width: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    height: 50px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
    .left-box {
        flex: 1;
        position: relative;
        input {
            padding-left: 20px;
            padding-right: 34px;
            width: 100%;
            height: 50px;
            font-size: 14px;
            color: var(--color-label);
            border: 1px solid transparent;
            box-shadow: none;
            margin: 0;
            @include ellipsis();
            &::placeholder,
            &:focus::placeholder {
                @include ellipsis();
            }
        }
        @include placeholderColor(var(--color-holder));
        .close-box {
            display: none;
            position: absolute;
            top: 50%;
            right: 20px;
            transform: translateY(-50%);
            height: 14px;
            width: 14px;
            cursor: pointer;
            &.show {
                display: block;
            }
            .icon-search-close {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                border-radius: 50%;
                width: 14px;
                height: 14px;
                &::before {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 14px;
                    color: var(--color-holder);
                    background-color: #fff;
                }
            }
        }
        .icon-search {
            position: absolute;
            top: 1px;
            bottom: 1px;
            right: 1px;
            width: 40px;
            background-color: #fff;
            cursor: pointer;
            display: none;
            &::before {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 16px;
                color: #c6c8d1;
            }
        }
    }
    .right-box {
        flex: none;
        position: relative;
        display: flex;
        .submit-btn {
            @include color-button-hover();
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            height: 50px;
            line-height: 50px;
            padding: 0 20px;
            font-size: 14px;
            font-family: var(--mg-button-font);
            cursor: pointer;
            color: var(--mg-button-color);
            background-color: var(--mg-button-background);
        }
        .submit-btn.submit-disabled {
            pointer-events: none;
            @include input-disabled();
        }
    }
    .empty-error {
        position: absolute;
        z-index: 1;
        top: 60px;
        left: 0;
        width: 245px;
        height: 40px;
        border-radius: 3px;
        background: #fff;
        &::before {
            content: '';
            position: absolute;
            width: 7px;
            height: 7px;
            left: 21px;
            top: -3px;
            transform: rotate(45deg);
            background: #fff;
        }
        .icon-error {
            margin-left: 12px;
            &::before {
                color: #ff3737;
                font-size: 20px;
                line-height: 40px;
                vertical-align: middle;
            }
        }
        .error-text {
            font-size: 15px;
            color: rgba(231, 0, 0, 0.6);
            line-height: 40px;
            vertical-align: middle;
        }
    }
    @include media-800 {
        width: 420px;
        background-color: #fff;
        height: 40px;
        .left-box {
            input {
                padding-left: 10px;
                padding-right: 50px;
                height: 40px;
            }
            .close-box.show {
                display: none;
            }
            .icon-search {
                display: block;
            }
        }
        .right-box {
            display: none;
        }
        .empty-error {
            top: 50px;
        }
    }
    @include media-600 {
        width: 254px;
    }
}
</style>
